<ul class="nav nav-pills gap-2 mb-4">
  <li class="nav-item" *ngFor="let item of itens">
    <button class="nav-link" [class.active]="aba === item.id" (click)="selecionar.emit(item.id)">{{ item.rotulo }}</button>
  </li>
  <li class="nav-item ms-auto">
    <button class="nav-link" (click)="sair.emit()">Sair</button>
  </li>
</ul>
